import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common";
import * as i2 from "../../../basic-features/icon-v2/icon.component";
import * as i3 from "./drag-and-drop.directive";
import * as i4 from "@ngx-translate/core";
const _c0 = ["fileDropRef"];
const _c1 = a0 => ({
  fileSize: a0
});
function UploadComponent_section_0_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function UploadComponent_section_0_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "section", 4);
    i0.ɵɵlistener("fileDropped", function UploadComponent_section_0_Template_section_fileDropped_0_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.onFileDropped($event));
    });
    i0.ɵɵtemplate(1, UploadComponent_section_0_ng_container_1_Template, 1, 0, "ng-container", 5);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    const content_r3 = i0.ɵɵreference(3);
    i0.ɵɵproperty("isFolderUpload", ctx_r1.isFolderUpload);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", content_r3);
  }
}
function UploadComponent_section_1_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function UploadComponent_section_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "section", 6);
    i0.ɵɵtemplate(1, UploadComponent_section_1_ng_container_1_Template, 1, 0, "ng-container", 5);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵnextContext();
    const content_r3 = i0.ɵɵreference(3);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", content_r3);
  }
}
function UploadComponent_ng_template_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 7)(1, "div", 8)(2, "input", 9, 1);
    i0.ɵɵlistener("change", function UploadComponent_ng_template_2_Template_input_change_2_listener($event) {
      i0.ɵɵrestoreView(_r4);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.onFilesAdded($event));
    });
    i0.ɵɵelementEnd();
    i0.ɵɵelement(4, "geaui-icon-v2", 10);
    i0.ɵɵelementStart(5, "span", 11);
    i0.ɵɵtext(6);
    i0.ɵɵpipe(7, "translate");
    i0.ɵɵpipe(8, "translate");
    i0.ɵɵelementStart(9, "label", 12);
    i0.ɵɵlistener("click", function UploadComponent_ng_template_2_Template_label_click_9_listener() {
      i0.ɵɵrestoreView(_r4);
      const fileDropRef_r5 = i0.ɵɵreference(3);
      return i0.ɵɵresetView(fileDropRef_r5.click());
    });
    i0.ɵɵtext(10);
    i0.ɵɵpipe(11, "translate");
    i0.ɵɵpipe(12, "translate");
    i0.ɵɵelementEnd()()();
    i0.ɵɵelementStart(13, "span", 13);
    i0.ɵɵtext(14);
    i0.ɵɵpipe(15, "translate");
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const fileDropRef_r5 = i0.ɵɵreference(3);
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("disabled", !ctx_r1.hasPermission);
    i0.ɵɵattribute("directory", ctx_r1.isFolderUpload ? "" : null)("webkitdirectory", ctx_r1.isFolderUpload ? "" : null)("mozdirectory", ctx_r1.isFolderUpload ? "" : null);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("color", ctx_r1.hasPermission ? "black" : "grey")("file", "32px_folder-upload");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1("", ctx_r1.isFolderUpload ? i0.ɵɵpipeBind1(7, 10, "UI.LIB.ATTACHMENTS.DROP-FOLDERS") : i0.ɵɵpipeBind1(8, 12, "UI.LIB.ATTACHMENTS.DROP-FILES"), " ");
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("for", fileDropRef_r5);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r1.isFolderUpload ? i0.ɵɵpipeBind1(11, 14, "UI.LIB.ATTACHMENTS.SELECT-FOLDERS") : i0.ɵɵpipeBind1(12, 16, "UI.LIB.ATTACHMENTS.SELECT-FILES"));
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind2(15, 18, "UI.LIB.ATTACHMENTS.MAX-FILE-SIZE-VARIABLE", i0.ɵɵpureFunction1(21, _c1, ctx_r1.showMaxFileSizeInMB())));
  }
}
export class UploadComponent {
  fileInput;
  hasPermission = false;
  isFolderUpload = false;
  maxFileSize = 150000000;
  filesAdded = new EventEmitter();
  fileDeleted = new EventEmitter();
  maxFileSizeExceeded = new EventEmitter();
  onFileDropped(files) {
    const fileList = [];
    for (let i = 0; i < files.length; i++) {
      const file = files[i];
      if (!file) continue;
      if (this.isMaxSizeGreaterThanFileSize(file)) {
        fileList.push(file);
      } else {
        this.maxFileSizeExceeded.emit();
      }
    }
    this.filesAdded.emit(fileList);
    this.clearFileInput();
  }
  onFilesAdded(event) {
    const files = event.target.files;
    if (files) {
      this.onFileDropped(files);
    }
  }
  showMaxFileSizeInMB() {
    const megabytes = this.maxFileSize / (1024 * 1024);
    return `${megabytes.toFixed(0)}MB`;
  }
  isMaxSizeGreaterThanFileSize(file) {
    return !this.maxFileSize || this.maxFileSize >= file.size;
  }
  clearFileInput() {
    if (this.fileInput) {
      this.fileInput.nativeElement.value = '';
    }
  }
  static ɵfac = function UploadComponent_Factory(t) {
    return new (t || UploadComponent)();
  };
  static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: UploadComponent,
    selectors: [["geaui-upload"]],
    viewQuery: function UploadComponent_Query(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵviewQuery(_c0, 5);
      }
      if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.fileInput = _t.first);
      }
    },
    inputs: {
      hasPermission: "hasPermission",
      isFolderUpload: "isFolderUpload",
      maxFileSize: "maxFileSize"
    },
    outputs: {
      filesAdded: "filesAdded",
      fileDeleted: "fileDeleted",
      maxFileSizeExceeded: "maxFileSizeExceeded"
    },
    decls: 4,
    vars: 2,
    consts: [["content", ""], ["fileDropRef", ""], ["class", "upload-container", "geauiDragAndDrop", "", 3, "isFolderUpload", "fileDropped", 4, "ngIf"], ["class", "upload-container disabled", 4, "ngIf"], ["geauiDragAndDrop", "", 1, "upload-container", 3, "fileDropped", "isFolderUpload"], [4, "ngTemplateOutlet"], [1, "upload-container", "disabled"], [1, "upload-flex-container"], [1, "upload-container-inner"], ["id", "fileDropRef", "type", "file", "multiple", "", "data-cy", "input", 2, "display", "none", 3, "change", "disabled"], [1, "upload-icon", 3, "color", "file"], [1, "gea-font-heading-16"], [1, "gea-font-heading-16", 3, "click", "for"], [1, "upload-max-file-size-text"]],
    template: function UploadComponent_Template(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵtemplate(0, UploadComponent_section_0_Template, 2, 2, "section", 2)(1, UploadComponent_section_1_Template, 2, 1, "section", 3)(2, UploadComponent_ng_template_2_Template, 16, 23, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor);
      }
      if (rf & 2) {
        i0.ɵɵproperty("ngIf", ctx.hasPermission);
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngIf", !ctx.hasPermission);
      }
    },
    dependencies: [i1.NgIf, i1.NgTemplateOutlet, i2.IconComponent, i3.DragAndDropDirective, i4.TranslatePipe],
    styles: [".upload-flex-container[_ngcontent-%COMP%]{display:flex;flex-direction:column;align-items:center;justify-content:center;border:2px solid var(--geaui-grey-05);gap:8px;padding:32px 0;margin-bottom:20px}.upload-max-file-size-text[_ngcontent-%COMP%]{font-size:14px;font-style:normal;font-weight:400;line-height:140%}.upload-container.fileover[_ngcontent-%COMP%]{background-color:var(--geaui-grey-05)}.upload-container-inner[_ngcontent-%COMP%]{display:flex;align-items:center;padding:0 40px;font-weight:700}.upload-container-inner[_ngcontent-%COMP%]   span[_ngcontent-%COMP%]{align-self:center;color:var(--geaui-pure-black);margin:0 5px}.upload-container-inner[_ngcontent-%COMP%]   label[_ngcontent-%COMP%]{color:var(--geaui-primary);cursor:pointer}.upload-container-inner.disabled[_ngcontent-%COMP%]{background:var(--geaui-grey-04);border-color:var(--geaui-grey-04);color:var(--geaui-grey-01);opacity:1;pointer-events:none}.upload-container-inner.disabled[_ngcontent-%COMP%]   span[_ngcontent-%COMP%], .upload-container-inner.disabled[_ngcontent-%COMP%]   label[_ngcontent-%COMP%]{color:var(--geaui-grey-01);cursor:default}.upload-icon[_ngcontent-%COMP%]{margin:0 5px}"]
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(UploadComponent, [{
    type: Component,
    args: [{
      selector: 'geaui-upload',
      template: "<section\n  class=\"upload-container\"\n  *ngIf=\"hasPermission\"\n  [isFolderUpload]=\"isFolderUpload\"\n  (fileDropped)=\"onFileDropped($event)\"\n  geauiDragAndDrop>\n  <ng-container *ngTemplateOutlet=\"content\"></ng-container>\n</section>\n\n<section class=\"upload-container disabled\" *ngIf=\"!hasPermission\">\n  <ng-container *ngTemplateOutlet=\"content\"></ng-container>\n</section>\n\n<ng-template #content>\n  <div class=\"upload-flex-container\">\n    <div class=\"upload-container-inner\">\n      <input\n        id=\"fileDropRef\"\n        #fileDropRef\n        [disabled]=\"!hasPermission\"\n        [attr.directory]=\"isFolderUpload ? '' : null\"\n        [attr.webkitdirectory]=\"isFolderUpload ? '' : null\"\n        [attr.mozdirectory]=\"isFolderUpload ? '' : null\"\n        (change)=\"onFilesAdded($event)\"\n        type=\"file\"\n        multiple\n        style=\"display: none\"\n        data-cy=\"input\" />\n      <geaui-icon-v2 class=\"upload-icon\" [color]=\"hasPermission ? 'black' : 'grey'\" [file]=\"'32px_folder-upload'\"></geaui-icon-v2>\n      <span class=\"gea-font-heading-16\"\n        >{{ isFolderUpload ? ('UI.LIB.ATTACHMENTS.DROP-FOLDERS' | translate) : ('UI.LIB.ATTACHMENTS.DROP-FILES' | translate) }}\n        <label class=\"gea-font-heading-16\" [for]=\"fileDropRef\" (click)=\"fileDropRef.click()\">{{\n          isFolderUpload ? ('UI.LIB.ATTACHMENTS.SELECT-FOLDERS' | translate) : ('UI.LIB.ATTACHMENTS.SELECT-FILES' | translate)\n        }}</label>\n      </span>\n    </div>\n    <span class=\"upload-max-file-size-text\">{{\n      'UI.LIB.ATTACHMENTS.MAX-FILE-SIZE-VARIABLE' | translate: { fileSize: showMaxFileSizeInMB() }\n    }}</span>\n  </div>\n</ng-template>\n",
      styles: [".upload-flex-container{display:flex;flex-direction:column;align-items:center;justify-content:center;border:2px solid var(--geaui-grey-05);gap:8px;padding:32px 0;margin-bottom:20px}.upload-max-file-size-text{font-size:14px;font-style:normal;font-weight:400;line-height:140%}.upload-container.fileover{background-color:var(--geaui-grey-05)}.upload-container-inner{display:flex;align-items:center;padding:0 40px;font-weight:700}.upload-container-inner span{align-self:center;color:var(--geaui-pure-black);margin:0 5px}.upload-container-inner label{color:var(--geaui-primary);cursor:pointer}.upload-container-inner.disabled{background:var(--geaui-grey-04);border-color:var(--geaui-grey-04);color:var(--geaui-grey-01);opacity:1;pointer-events:none}.upload-container-inner.disabled span,.upload-container-inner.disabled label{color:var(--geaui-grey-01);cursor:default}.upload-icon{margin:0 5px}\n"]
    }]
  }], null, {
    fileInput: [{
      type: ViewChild,
      args: ['fileDropRef']
    }],
    hasPermission: [{
      type: Input
    }],
    isFolderUpload: [{
      type: Input
    }],
    maxFileSize: [{
      type: Input
    }],
    filesAdded: [{
      type: Output
    }],
    fileDeleted: [{
      type: Output
    }],
    maxFileSizeExceeded: [{
      type: Output
    }]
  });
})();
